export const getHoliday = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const [year, month, day] = value.split('-').map(Number);
  const fixed = {'01-01':"New Year's Day",'06-19':'Juneteenth','07-04':'Independence Day','11-11':'Veterans Day','12-24':'Christmas Eve','12-25':'Christmas Day','12-31':"New Year's Eve"};
  if (fixed[value.slice(5)]) return fixed[value.slice(5)];
  const nth = (m, weekday, n) => 1 + (weekday - new Date(year, m - 1, 1).getDay() + 7) % 7 + 7 * (n - 1);
  const thanksgiving = nth(11, 4, 4);
  const memorial = 31 - (new Date(year, 4, 31).getDay() + 6) % 7;
  if (month === 1 && day === nth(1, 1, 3)) return 'Martin Luther King Jr. Day';
  if (month === 2 && day === nth(2, 1, 3)) return "Presidents' Day";
  if (month === 5 && day === memorial) return 'Memorial Day';
  if (month === 9 && day === nth(9, 1, 1)) return 'Labor Day';
  if (month === 11 && day === thanksgiving) return 'Thanksgiving Day';
  if (month === 11 && day === thanksgiving + 1) return 'Black Friday';
  return null;
};

export const localDate = () => new Intl.DateTimeFormat('en-CA', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());

// Keep an uncertain submission stable across reloads and network retries.
export const submissionId = () => {
  const key = 'pending_booking_submission';
  let value = sessionStorage.getItem(key);
  if (!value) { value = crypto.randomUUID(); sessionStorage.setItem(key, value); }
  return value;
};
export const finishSubmission = () => sessionStorage.removeItem('pending_booking_submission');
